import { absolutePath } from "./absolutePath";

export const paywallsAffiliatesSettings = {
  show: () => absolutePath("paywalls/affiliates/settings"),
  update: () => absolutePath("paywalls/affiliates/settings"),
};
